import React from 'react'
import ContentLoader from "react-content-loader"

function Skeleton(props) {
    return (
        <ContentLoader 
    speed={2}
    width={400}
    height={160}
    viewBox="0 0 400 160"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="8" y="111" rx="3" ry="3" width="410" height="6" /> 
    <rect x="7" y="40" rx="3" ry="3" width="380" height="48" /> 
    <rect x="9" y="126" rx="3" ry="3" width="178" height="6" /> 
    <rect x="8" y="97" rx="3" ry="3" width="410" height="6" />
  </ContentLoader>
    )
}

export default Skeleton
